<div class="auth-container flex justify-center items-center relative overflow-hidden">
    <div class="_left"></div>
    <div class="_right"></div>
    <ng-content></ng-content>
    <div class="bottom-image absolute">
      <img class="w-100" src="assets/images/art-gallery-for-children-bottom.png" alt="art-gallery-for-children">
    </div>
  </div>
  <!-- <div class="container-signup flex justify-center items-center overflow-hidden"></div> -->